import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"

interface AdminEmptyStateProps {
  icon?: React.ReactNode
  title: string
  description?: string
  actionHref?: string
  actionLabel?: string
  variant?: "default" | "success"
}

export function AdminEmptyState({
  icon,
  title,
  description,
  actionHref,
  actionLabel,
  variant = "default",
}: AdminEmptyStateProps) {
  if (variant === "success") {
    return (
      <div className="rounded-2xl border border-emerald-200 bg-emerald-50 py-16 text-center">
        {icon && (
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100 text-emerald-500">
            {icon}
          </div>
        )}
        <p className="text-sm font-medium text-emerald-700">{title}</p>
        {description && <p className="mt-1 text-xs text-emerald-600">{description}</p>}
      </div>
    )
  }

  return (
    <div className="py-16 text-center">
      {icon && (
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
          {icon}
        </div>
      )}
      <p className="text-sm font-medium text-muted-foreground">{title}</p>
      {description && <p className="mt-1 text-xs text-muted-foreground/80">{description}</p>}
      {actionHref && actionLabel && (
        <Button variant="link" asChild className="mt-4">
          <Link to={actionHref}>
            {actionLabel} &rarr;
          </Link>
        </Button>
      )}
    </div>
  )
}
